import { getAmount, } from '@debbie/common/dist/economy/payment-plans/index.js';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../../theme.js';
import ArrowRight from '../../Icons/ArrowRight.js';
import Money from '../../Money.js';
import { intervalLabel } from './labels.js';
const PlanInfo = (props) => {
    const { paymentPlan, singleCase } = props;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(StatsGrid, null,
        React.createElement(StatCard, null,
            React.createElement(StatLabel, null, lang.paymentPlans.createdAt),
            React.createElement(StatValue, null, moment(paymentPlan.createdAt).format(THEME.DATE_FORMAT_SHORT))),
        React.createElement(StatCard, null,
            React.createElement(StatLabel, null, lang.paymentPlans.startDate),
            React.createElement(StatValue, null,
                moment(paymentPlan.plan[0]?.date).format(THEME.DATE_FORMAT_SHORT),
                React.createElement(ArrowRight, null),
                moment(paymentPlan.plan[paymentPlan.plan.length - 1]?.date).format(THEME.DATE_FORMAT_SHORT))),
        React.createElement(StatCard, null,
            React.createElement(StatLabel, null, lang.paymentPlans.entries),
            React.createElement(StatValue, null, paymentPlan.plan.length)),
        React.createElement(StatCard, null,
            React.createElement(StatLabel, null, lang.paymentPlans.amount),
            React.createElement(StatValue, null,
                React.createElement(Money, { amount: paymentPlan.config?.method === 'amount'
                        ? paymentPlan.config.amount || 0
                        : getAmount.entry(paymentPlan.plan) || 0, currency: singleCase?.currency }),
                ' ',
                React.createElement(PerLabel, null,
                    "/",
                    lang.paymentPlans.month))),
        paymentPlan.config?.interval && (React.createElement(StatCard, null,
            React.createElement(StatLabel, null, lang.paymentPlans.interval),
            React.createElement(StatValue, null, intervalLabel(paymentPlan.config.interval, lang))))));
};
export default PlanInfo;
const StatsGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 8px;
`;
const StatCard = styled.div `
  background: #fff;
  border: 1px solid ${THEME.BORDER};
  border-radius: 6px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
const StatLabel = styled.span `
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${THEME.TEXT_MUTED};
  font-weight: 600;
`;
const StatValue = styled.span `
  font-size: 15px;
  font-weight: 600;
  color: #222;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
`;
const PerLabel = styled.span `
  font-size: 12px;
  color: ${THEME.TEXT_MUTED};
  font-weight: 400;
`;
//# sourceMappingURL=PlanInfo.js.map